import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import './auth.css'

/** Campo de senha com botão mostrar/ocultar. */
export default function PasswordInput(props: { id: string; value: string; onChange: (v: string) => void; autoComplete: string; placeholder?: string; minLength?: number; required?: boolean; describedBy?: string }) {
  const [show, setShow] = useState(false)
  return (
    <div style={{ position: 'relative' }}>
      <input
        id={props.id}
        className="input"
        type={show ? 'text' : 'password'}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        autoComplete={props.autoComplete}
        placeholder={props.placeholder}
        minLength={props.minLength}
        aria-describedby={props.describedBy}
        required={props.required}
        style={{ paddingRight: 48 }}
      />
      <button type="button" className="pw-eye" aria-label={show ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={show} onClick={() => setShow(!show)}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  )
}
